export function UserLanguageViewConstructor(services, callbacks, context, siteTypeConfig) {

  let joint = services.joint;

  return joint.shapes.html.AbstractElementView.extend({

    isElementEditable: true,
    editElementModalController: 'editUserLanguageController',
    editElementModalTemplate: require('./editUserLanguage.modal.html'),

    angularTemplate: `
    <div layout="column">
      <span> {{ elementData.label }} </span>
    </div>
    `,

    init: function () {
      setTimeout(() => {
        if (this.angularScope && this.angularScope.elementData) {
          if (!this.angularScope.elementData.lang) {
            this.editElement();
          } else if (this.angularScope.elementData.lang === 'unknown') {
            this.isElementEditable = false
          }
        }
      }, 0)
    },

    getAlreadySelectedUserLanguages: function () {
      const parent = this.model.getAncestors()[0];
      const embeddedCells = parent.getEmbeddedCells();
      const selected = [];
      for (let child of embeddedCells) {
        selected.push(child.get('elementData').lang);
      }
      return selected;
    },

  });
}

